import styles from './SideNavLinks.module.scss';
import { userHasPermission } from '@casops/permissions';
import { useAppSelector } from '@casops/store/hooks';
import { NavLinkData } from '@casops/navigation';
import SideNavLink from '../side-nav-link/SideNavLink';
import { ReactElement } from 'react';

interface SideNavLinksProps {
  isOpen: boolean;
  links: NavLinkData[];
}

export const SideNavLinks = ({ isOpen, links }: SideNavLinksProps): ReactElement => {
  const userData = useAppSelector(state => state.auth);

  const authorisedLinks = userData.isLoggedIn
    ? links.filter(link => userHasPermission(userData, link.permission))
    : [];

  return (
    <div className={styles.links}>
      {authorisedLinks.map(link => (
        <SideNavLink key={link.key} linkData={link} isOpen={isOpen} />
      ))}
    </div>
  );
};

export default SideNavLinks;
